const reducer = state => ({
  ...state,
  currentApiRequest: null,
});

export default reducer;
